export function TherapistsListSkeleton() {
  return (
    <>
      {/* Desktop table skeleton */}
      <div className="hidden overflow-hidden rounded-2xl border border-border/60 bg-card shadow-sm lg:block">
        <div className="h-10 bg-muted/40" />
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="flex items-center gap-4 border-b border-border/40 px-4 py-3 last:border-b-0"
          >
            <div className="size-8 shrink-0 animate-pulse rounded-full bg-muted" />
            <div className="flex-1 space-y-1.5">
              <div className="h-3.5 w-36 animate-pulse rounded bg-muted" />
              <div className="h-3 w-48 animate-pulse rounded bg-muted/60" />
            </div>
            <div className="hidden h-5 w-32 animate-pulse rounded-md bg-muted/50 xl:block" />
            <div className="h-3.5 w-16 animate-pulse rounded bg-muted/40" />
            <div className="h-6 w-24 animate-pulse rounded-full bg-muted/60" />
          </div>
        ))}
      </div>

      {/* Mobile/Tablet card skeletons */}
      <div className="grid gap-3 sm:grid-cols-2 lg:hidden">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="rounded-2xl border border-border/60 bg-card p-4 shadow-sm"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="size-11 shrink-0 animate-pulse rounded-full bg-muted" />
                <div className="space-y-1.5">
                  <div className="h-4 w-32 animate-pulse rounded bg-muted" />
                  <div className="h-3 w-40 animate-pulse rounded bg-muted/60" />
                </div>
              </div>
              <div className="h-6 w-20 animate-pulse rounded-full bg-muted/60" />
            </div>
            <div className="mt-3 flex gap-1.5">
              <div className="h-5 w-20 animate-pulse rounded-md bg-muted/50" />
              <div className="h-5 w-24 animate-pulse rounded-md bg-muted/50" />
            </div>
            <div className="mt-3 flex justify-between border-t border-border/40 pt-3">
              <div className="h-3.5 w-24 animate-pulse rounded bg-muted/40" />
              <div className="h-3.5 w-20 animate-pulse rounded bg-muted/40" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
